var render = function render(){var _vm=this,_c=_vm._self._c;return _c('multiselect',{attrs:{"placeholder":"All","selectLabel":"","show-labels":false,"options":_vm.options},on:{"input":_vm.updateFilters},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }